import { StateSchema } from 'app/config/storeConfig/types';
import { GratitudeModalSchema } from '../types';

export const getGratitudeModalState = (state: StateSchema): GratitudeModalSchema => state.gratitudeModal;
